module.exports = __webpack_public_path__ + "b0f59cee617475a4f65535f0b9c55e52.svg";